import { render, staticRenderFns } from "./NamePage.vue?vue&type=template&id=2506ee92&scoped=true"
import script from "./NamePage.vue?vue&type=script&lang=ts"
export * from "./NamePage.vue?vue&type=script&lang=ts"
import style0 from "./NamePage.vue?vue&type=style&index=0&id=2506ee92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2506ee92",
  null
  
)

export default component.exports